import React, {createRef, useEffect} from "react";
import ReactPlayer from "react-player/youtube";
import SectionTitle from "../SectionTitle";
import {
  DashedLine,
  Video,
  Link,
  Book,
  ScrollBar,
  Info,
  VideoPallino,
  Grafiche,
  Lezioni,
  QuizPallino,
  Pallino,
  Film,
} from "./Icons";
import Footer from "../Footer";
import infograficaUno from "./infograficaUno.pdf";
import infograficaDue from "./infograficaDue.pdf";
import lezioneNove from "./Lezione_2.3_9.pdf";
import lezioneDodici from "./Lezione_2.3_12.pdf";
import quizUnoNove from "./Quiz_2.1_9.pdf";
import quizUnoDodici from "./Quiz_2.1_12.pdf";
import quizDueNove from "./Quiz_2.2_9.pdf";
import quizDueDodici from "./Quiz_2.2_12.pdf";
import quizTreNove from "./Quiz_2.3_9.pdf";
import quizTreDodici from "./Quiz_2.3_12.pdf";
import attestato from "./attestato.pdf";

import {
  Wrap,
  Intro,
  VideoWrapper,
  InfoGraphics,
  Lessons,
  Quizzes,
  Certification,
  Links,
  FiltersTabs,
  FiltersTabList,
  FilterTab,
  FilterTabPanelLesson,
  FilterTabPanelQuiz,
  Space,
  ScrollContainer,
  PallinoWrap,
} from "./styles";

export default function SectionContentCapire(props) {
  const ScrollBarWithRef = React.forwardRef((props, ref) => (
    <div ref={ref}>
      <ScrollBar />
    </div>
  ));
  const scrollRef = createRef(null);

  const imageToShow = (pos) => {
    switch (true) {
      case pos >= 0 && pos < 1237:
        return "info";
      case pos >= 1237 && pos < 1879:
        return "video";
      case pos >= 1879 && pos < 2489:
        return "grafiche";
      case pos >= 2489 && pos < 3975:
        return "lezioni";
      case pos >= 3975 && pos < 4793:
        return "quiz";
      default:
        return "pallino";
    }
  };

  useEffect(() => {
    imageToShow(props.pos);
  }, [props.pos]);

  return (
    <Wrap>
      <ScrollContainer>
        <ScrollBarWithRef ref={scrollRef} />
      </ScrollContainer>
      <PallinoWrap opacity={imageToShow(props.pos)}>
        <Info />
        <VideoPallino />
        <Grafiche />
        <Lezioni />
        <QuizPallino />
        <Pallino />
      </PallinoWrap>
      <Intro>
        <SectionTitle title="INTRODUZIONE" />
        <h2>{props.mainTitleFirstPart}</h2>
        {props.mainTitleSecondPart && <h2>{props.mainTitleSecondPart}</h2>}
        <section>
          <div>
            <article>{props.description}</article>
          </div>
          <div>
            {props.checkPoints.map((c, i) => (
              <span key={i}>
                <svg width="37" height="29">
                  <path
                    d="M32.107 0L37 5.108 14.111 29 0 14.27l4.893-5.107 9.218 9.622z"
                    fill="#F5A462"
                    fillRule="evenodd"
                  />
                </svg>
                {c.toUpperCase()}
              </span>
            ))}
          </div>
        </section>
      </Intro>

      <VideoWrapper>
        <div>
          <SectionTitle title="UN VIDEO PER INIZIARE" />
          <h2>{props.videoTitle}</h2>
        </div>
        <div>
          <ReactPlayer width="100%" height="auto" url="https://youtu.be/mfwSvBMzFfs" />
        </div>
      </VideoWrapper>

      <InfoGraphics>
        <div>
          <SectionTitle title="DIAMO I NUMERI" />
          <h2>{props.infographicTitle}</h2>
        </div>
        <div>
          <section>
            <a href={infograficaUno} target="_blank" rel="noopener noreferrer" >
              <div></div>
              <button>SCARICA ORA</button>
            </a>
          </section>
          <span />
          <section>
            <a href={infograficaDue} target="_blank" rel="noopener noreferrer" >
              <div></div>
              <button>SCARICA ORA</button>
            </a>
          </section>
        </div>
      </InfoGraphics>

      <Lessons>
        <div>
          <SectionTitle title="PROPOSTE DI LEZIONE" />
          <h2>{props.lessonsTitle}</h2>
          <p>{props.lessonDescription}</p>
          <span>Seleziona la fascia d'età</span>
          <div>
            <FiltersTabs>
              <FiltersTabList>
                <FilterTab>9 - 11 ANNI</FilterTab>
                <FilterTab>12 - 14 ANNI</FilterTab>
              </FiltersTabList>
              <FilterTabPanelLesson>
                <div>
                  <section>
                    <a
                      href="https://view.genial.ly/60a54470d94b440d24b1ef92/presentation-lez-21-9-11-anni-ingiustizie-climatiche"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div></div>
                      <button>GUARDA LA LEZIONE INTERATTIVA</button>
                    </a>
                  </section>
                  <span />
                  <section>
                    <a
                      href="https://view.genial.ly/609b9cf669af6e0d353373ce/presentation-lez-22-9-11-anni-guerre-climatiche-e-migrazioni-ambientali"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div></div>
                      <button>GUARDA LA LEZIONE INTERATTIVA</button>
                    </a>
                  </section>
                </div>
                <div>
                  <section>
                    <a href={lezioneNove} target="_blank" rel="noopener noreferrer" >
                      <div></div>
                      <button>SCARICA LA SCHEDA E L’ATTIVITÀ</button>
                    </a>
                  </section>
                </div>
              </FilterTabPanelLesson>
              <FilterTabPanelLesson>
                <div>
                  <section>
                    <a
                      href="https://view.genial.ly/609a4bafa2f1310dc31772c3/presentation-lez-21-12-14-anni-ingiustizie-climatiche"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div></div>
                      <button>GUARDA LA LEZIONE INTERATTIVA</button>
                    </a>
                  </section>
                  <span />
                  <section>
                    <a
                      href="https://view.genial.ly/609e46ea5cff340d3172fefd/presentation-lez-22-12-14-anni-guerre-climatiche-e-migrazioni-ambientali"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div></div>
                      <button>GUARDA LA LEZIONE INTERATTIVA</button>
                    </a>
                  </section>
                </div>
                <div>
                  <section>
                    <a href={lezioneDodici} target="_blank" rel="noopener noreferrer" >
                      <div></div>
                      <button>SCARICA LA SCHEDA E L’ATTIVITÀ</button>
                    </a>
                  </section>
                </div>
              </FilterTabPanelLesson>
            </FiltersTabs>
          </div>
        </div>
      </Lessons>

      <Quizzes>
        <div>
          <SectionTitle title="QUIZ" />
          <h2>{props.quizTitle}</h2>
          <p>{props.quizDescription}</p>
          <span>Seleziona la fascia d'età</span>
          <div>
            <FiltersTabs>
              <FiltersTabList>
                <FilterTab>9 - 11 ANNI</FilterTab>
                <FilterTab>12 - 14 ANNI</FilterTab>
              </FiltersTabList>
              <FilterTabPanelQuiz>
                <div>
                  <DashedLine />
                  <Space />
                  <div>
                    <a href={quizUnoNove} target="_blank" rel="noopener noreferrer" >
                      <button>SCARICA ORA</button>
                    </a>
                    <a href={quizUnoNove} target="_blank" rel="noopener noreferrer" >
                      <p>QUIZ 2.1 | Ingiustizie climatiche</p>
                    </a>
                  </div>
                  <div>
                    <a href={quizDueNove} target="_blank" rel="noopener noreferrer" >
                      <button>SCARICA ORA</button>
                    </a>
                    <a href={quizDueNove} target="_blank" rel="noopener noreferrer" >
                      <p>QUIZ 2.2 | Guerre climatiche e migrazioni</p>
                    </a>
                  </div>
                  <div>
                    <a href={quizTreNove} target="_blank" rel="noopener noreferrer" >
                      <button>SCARICA ORA</button>
                    </a>
                    <a href={quizTreNove} target="_blank" rel="noopener noreferrer" >
                      <p>QUIZ 2.3 | I diritti dei bambini e la crisi climatica</p>
                    </a>
                  </div>
                </div>
              </FilterTabPanelQuiz>
              <FilterTabPanelQuiz>
                <div>
                  <DashedLine />
                  <Space />
                  <div>
                    <a href={quizUnoDodici} target="_blank" rel="noopener noreferrer" >
                      <button>SCARICA ORA</button>
                    </a>
                    <a href={quizUnoDodici} target="_blank" rel="noopener noreferrer" >
                      <p>QUIZ 2.1 | Ingiustizie climatiche</p>
                    </a>
                  </div>
                  <div>
                    <a href={quizDueDodici} target="_blank" rel="noopener noreferrer" >
                      <button>SCARICA ORA</button>
                    </a>
                    <a href={quizDueDodici} target="_blank" rel="noopener noreferrer" >
                      <p>QUIZ 2.2 | Guerre climatiche e migrazioni</p>
                    </a>
                  </div>
                  <div>
                    <a href={quizTreDodici} target="_blank" rel="noopener noreferrer" >
                      <button>SCARICA ORA</button>
                    </a>
                    <a href={quizTreDodici} target="_blank" rel="noopener noreferrer" >
                      <p>QUIZ 2.3 | I diritti dei bambini e la crisi climatica</p>
                    </a>
                  </div>
                </div>
              </FilterTabPanelQuiz>
            </FiltersTabs>
          </div>
        </div>
      </Quizzes>

      <Certification>
        <div>
          <SectionTitle title="ATTESTATO" />
          <h2>{props.certificateTitle}</h2>
          <p>{props.certificateDescription}</p>
          <a href={attestato} target="_blank" rel="noopener noreferrer" >
            <button>SCARICA L'ATTESTATO</button>
          </a>
        </div>
      </Certification>

      <Links>
        <div>
          <h2>{props.linksTitle}</h2>
        </div>

        <div>
          <h1>VIDEO</h1>
          <div>
            <div>
              <Video />
            </div>
            <a href="https://youtu.be/m3zyyE4Dyd0" target="_blank" rel="noopener noreferrer">
              <p>Ambiente e migrazioni | HUB Scuola (2020)</p>
            </a>
          </div>
          <div>
            <div>
              <Video />
            </div>
            <a href="https://www.youtube.com/watch?v=dbZ0V7YfHCw" target="_blank" rel="noopener noreferrer">
              <p>Acqua e Clima: le sfide del nostro secolo! | CeVI (2019)</p>
            </a>
          </div>
          <div>
            <div>
              <Video />
            </div>
            <a href="https://youtu.be/EgAFrCs2aqc" target="_blank" rel="noopener noreferrer">
              <p>Che ruolo ha il cambiamento climatico sulla pace e la guerra | TEDxVarese (2017)</p>
            </a>
          </div>
        </div>
        <div>
          <h1>ARTICOLI E SITI WEB</h1>
          <div>
            <div>
              <Link />
            </div>
            <a
              href="https://www.unhcr.org/it/notizie-storie/storie/il-cambiamento-climatico-e-la-crisi-che-caratterizza-il-nostro-tempo-e-colpisce-in-particolare-le-persone-costrette-alla-fuga/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p>
                Il cambiamento climatico è la crisi che caratterizza il nostro tempo e colpisce in particolare le
                persone costrette alla fuga | Harper A., UNHCR (2021)
              </p>
            </a>
          </div>
          <div>
            <div>
              <Link />
            </div>
            <a
              href="https://openmigration.org/analisi/migranti-e-cambiamenti-climatici-chi-migra-perche-e-come-intervenire-per-porvi-rimedio/#/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p>
                Migranti e cambiamenti climatici. Chi migra, perché e come intervenire per porvi rimedio? | Andreucci
                D., Oleandri A., Open Migration (2019)
              </p>
            </a>
          </div>
          <div>
            <div>
              <Link />
            </div>
            <a
              href="https://www.aics.gov.it/oltremare/articoli/pianeta/rifugiati-climatici-e-ambientali-arriva-il-riconoscimento-giuridico-in-italia/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p>
                Rifugiati climatici e ambientali, arriva il riconoscimento giuridico in Italia | Bompan E., Oltremare
                (2021)
              </p>
            </a>
          </div>
          <div>
            <div>
              <Link />
            </div>
            <a href="http://edu-kit.sameworld.eu/?lang=it" target="_blank" rel="noopener noreferrer">
              <p>SAMEWORLD | Argomenti, attività da realizzare in classe e risorse online per educatori (2015)</p>
            </a>
          </div>
        </div>
        <div>
          <h1>LIBRI E FILM</h1>
          <div>
            <div>
              <Book />
            </div>
            <p>Effetto serra, effetto guerra | Mastrojeni G., Pasini A. (2017)</p>
          </div>
          <div>
            <div>
              <Film />
            </div>
            <a href="https://www.interdependencefilm.com/" target="_blank" rel="noopener noreferrer">
              <p>Interdependence | Art of the World (2019)</p>
            </a>
          </div>
        </div>
      </Links>
      <Footer />
    </Wrap>
  );
}
